import type { ExtensionsCommandFactory } from '../ExtensionsModel';
import { getExtensionLogs } from './api/getExtensionLogsApi';

export const refreshExtensionLogsCommand: ExtensionsCommandFactory<{
  extensionId: string;
}> = (cmdContext) => async (command) => {
  try {
    cmdContext.updateState((draft) => {
      draft.extensionDetails!.logsRefreshing = true;
    });

    const logsResponse = await getExtensionLogs(
      cmdContext.api,
      command.extensionId,
    );

    cmdContext.updateState((draft) => {
      draft.extensionDetails!.logsRefreshing = false;
      draft.extensionDetails!.logs = logsResponse?.logs ?? [];
    });
  } finally {
    cmdContext.updateState((draft) => {
      draft.extensionDetails!.logsRefreshing = false;
    });
  }
};
